/** 一局游戏固定包含 6 个委托，委托轮数依次为 5、6、7、8、9、10。 */
export const SANDBOX_COMMISSION_ROUNDS = [5, 6, 7, 8, 9, 10];

/** 沙盒页面用于编排 BattleManager 的外层流程阶段。 */
export type SandboxFlowStage =
  | "idle"
  | "recipeChoice"
  | "beforeRound"
  | "materialChoice"
  | "commissionSummary"
  | "gameSettling"
  | "gameEnded";

/** 当前弹窗选择的业务类型。 */
export type SandboxChoiceKind = "recipe" | "material" | "consumable";

/** 获取指定委托的基础轮数，不包含长柄勺等节点带来的额外轮数。 */
export function getBaseCommissionRoundLimit(commissionIndex: number): number {
  return SANDBOX_COMMISSION_ROUNDS[Math.max(0, commissionIndex - 1)] ?? 0;
}

/** 获取指定委托的总轮数，包含当前运行时状态里的额外调和次数。 */
export function getCommissionRoundLimit(commissionIndex: number, extraRounds = 0): number {
  return getBaseCommissionRoundLimit(commissionIndex) + Math.max(0, extraRounds);
}

/** 将沙盒流程阶段转为状态栏可读文本。 */
export function getSandboxFlowStageLabel(stage: SandboxFlowStage): string {
  switch (stage) {
    case "recipeChoice":
      return "选择配方";
    case "beforeRound":
      return "回合开始前";
    case "materialChoice":
      return "选择原料";
    case "commissionSummary":
      return "委托结算";
    case "gameSettling":
      return "游戏结算";
    case "gameEnded":
      return "游戏结束";
    case "idle":
    default:
      return "未开始";
  }
}
